var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":""}},[_c('Header'),_vm._t("default"),_c('HeaderBottom')],2)}
var staticRenderFns = []

export { render, staticRenderFns }